import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandModelService } from 'app/services/models/brand-model.service';
import { BrandService } from 'app/services/models/brand.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-brand-model',
  templateUrl: './create-brand-model.component.html',
  styleUrls: ['./create-brand-model.component.scss']
})
export class CreateBrandModelComponent implements OnInit {
  @Input() brandId: number;
  brandModelForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private brandService: BrandService,
    private brandModelSerivce: BrandModelService,
    private toastSerivce: ToastrService,
  ) { }

  async ngOnInit() {
    this.brandModelForm = this.fb.group({
      brandId: [this.brandId ?? null, Validators.required],
      brandModelName: [null, [Validators.required]]
    });
    await this.getAllBrand();
  }

  brands: any[];
  async getAllBrand() {
    const data = await this.brandService.getBrands();
    this.brands = data;
    console.log(this.brands);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.brandModelForm.valid) {
      console.log(this.brandModelForm.value);
      const response = await this.brandModelSerivce.createBrandModels(this.brandModelForm.value.brandModelName, this.brandModelForm.value.brandId);
      if (response.status) {
        //this.brandService.sendEvent(true);
        this.toastSerivce.success(response.message);
        this.activeModal.close(true);
      } else {
        this.toastSerivce.error(response.message);
      }
    }
  }
}